<ion-card>
    <ion-card-content>
        <ion-label>Required Detail Lines:</ion-label>
        <ion-list *ngIf="document.parentDocument && document.parentDocument.detailLines.length > 0">
            <ion-item *ngFor="let item of document.parentDocument.detailLines; index as i;"
                      (click)="updateContract(item)">
                <ion-label *ngIf="item.pdesc" class="ion-text-wrap"
                           [color]="checkFulfilment(item) < item.qty ? 'danger' : 'success'">
                    <p>{{item.qty}} - {{item.overrideDescriptionNote ? item.overrideDescriptionNote : item.description}}</p>
                    <p>Selected {{checkFulfilment(item)}} of {{item.qty}}</p>
                </ion-label>
                <ion-label *ngIf="item.plu" class="ion-text-wrap"
                           [color]="checkFulfilment(item) < item.qty ? 'danger' : 'success'">
                    <p>{{item.qty}} - {{item.comment ? item.comment : item.description}}</p>
                    <p>Selected {{checkFulfilment(item)}} of {{item.qty}}</p>
                </ion-label>
            </ion-item>
        </ion-list>
    </ion-card-content>

</ion-card>
